import { render, staticRenderFns } from "./SurveyFreezerDetail.vue?vue&type=template&id=7741506a&"
import script from "./SurveyFreezerDetail.vue?vue&type=script&lang=js&"
export * from "./SurveyFreezerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports